import { OrderAction } from '@/infrastructure/api/order';
import { Cooperative, Market } from './entity';
import { LineItem } from './lineItem';

export const OrderActionToStatusMap: { [key in OrderAction]: OrderStatus } = {
  CONFIRM_ORDER: 'PREPARING',
  SHIP_ORDER: 'OUT_FOR_DELIVERY',
  DELIVER_ORDER: 'DELIVERED',
  COMPLETE_ORDER: 'COMPLETED',
  CANCEL_ORDER: 'CANCELLED',
};

export const OrderActionStatusMap: { [key in OrderStatus]: OrderAction } = {
  PENDING: 'CONFIRM_ORDER',
  PREPARING: 'SHIP_ORDER',
  OUT_FOR_DELIVERY: 'DELIVER_ORDER',
  DELIVERED: 'COMPLETE_ORDER',
  COMPLETED: 'COMPLETE_ORDER',
  CANCELLED: 'CANCEL_ORDER',
  REFUNDED: 'CONFIRM_ORDER',
  RETURNED: 'CONFIRM_ORDER',
};

export const OrderStatusDisplayMap: { [key in OrderStatus]: string } = {
  PENDING: 'Order Placed',
  PREPARING: 'Order Confirmed and Being Prepared',
  OUT_FOR_DELIVERY: 'Order is Out for Delivery',
  DELIVERED: 'Order Has Been Delivered',
  COMPLETED: 'Order Has Been Completed',
  CANCELLED: 'Order Has Been Cancelled',
  REFUNDED: 'Order Has Been Refunded',
  RETURNED: 'Order Has Been Returned',
};

export type OrderStatus =
  | 'PENDING'
  | 'PREPARING'
  | 'OUT_FOR_DELIVERY'
  | 'DELIVERED'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'REFUNDED'
  | 'RETURNED';

export type OrderTimelineEvent = {
  metadata?: {
    status: OrderAction;
  };
  createdAt: string;
};

export type OrderProperties = {
  [key: string]: string | number | boolean | null;
};

export type Order = {
  id: string;
  marketId: string;
  market: Market;
  cooperativeId: string;
  cooperative: Cooperative;
  userId: string;
  subtotal: string;
  total: string;
  notes: string;
  number: string;
  reference: string;
  properties: OrderProperties;
  status: OrderStatus;
  createdAt: string;
  updatedAt: string;
  deliverOn: string;
  deliveredAt: string | null;
  receivedAt: string | null;
  cancelledAt: string | null;
  deletedAt: string | null;
  lineItems: LineItem[];
  timeline?: OrderTimelineEvent[];
  hasRefund?: boolean;
  voucherRedemptions?: {
    id: string;
    voucherCode: string;
    voucher: {
      id: string;
      description: string;
      type: 'FLAT_AMOUNT' | 'PERCENTAGE';
      value: number;
    };
  }[];
};

export type RefundStatus =
  | 'UNDER_REVIEW'
  | 'PENDING'
  | 'CANCELLED'
  | 'RETURNED'
  | 'REFUNDED'
  | 'REJECTED'
  | 'COMPLETED';

export type Refund = {
  id: string;
  orderId: string;
  cooperativeId: string;
  marketId: string;
  lineItems: LineItem[];
  images: string[];
  reason: string;
  solution: string;
  description: string;
  refundAmount: string;
  email: string;
  status: RefundStatus;
  createdAt: string;
  updatedAt: string;
  refundedAt?: string;
  cancelledAt?: string;
  returnedAt?: string;
  completedAt?: string;
  deletedAt?: string;

  order?: Order;
  cooperative?: Cooperative;
  market?: Market;
};
